export const instagramUrl = 'https://www.instagram.com/bright_digital_hubonline/'
export const checkoutUrl = 'https://complete-injury-rehabilitation-bundle.impultienda.ar/checkout'
export const offerAnchor = '#offer'
export const contactEmail = 'compradigitalyaa@gmail.com'

export const mockupUrl =
  'https://cdn.magicpatterns.com/uploads/aEv4ZTRqeDS5ngvhf1kjrs/Paquete_Completo_de_Rehabilitacion_de_Lesiones.png'

export const photos = {
  bandRotation:
    'https://cdn.magicpatterns.com/patterns/generated-images/81572498-7320-4ec1-92d4-cdda6ca80543.jpg',
}

export const bodyAreas = ['Shoulder', 'Knee', 'Ankle', 'Elbow, Wrist & Hand', 'Spine & Hip']

export const organizedNeeds = [
  'Need a mobility drill? It is organized.',
  'Need strengthening? It is organized.',
  'Need a home option, gym variation, warm-up or mobility routine? It is included.',
]

export const systemFlow = ['Open the system', 'Choose the area', 'Follow the exercise', 'Progress']

export const showcaseFeatures = [
  'Mobility & activation exercises',
  'Strengthening progressions',
  'Stability & movement-control exercises',
  'Beginner → Intermediate → Advanced options',
  'Home exercise variations',
  'Gym exercise variations',
  'Sets, reps & rest periods included',
  'Regressions & progressions included',
]

export const volumes = [
  {
    number: '01',
    name: 'Shoulder Rehabilitation & Strengthening',
    text: 'Build a clearer shoulder exercise progression with mobility, rotator cuff activation, scapular control, strengthening and stability work.',
    detail: 'Use beginner, intermediate and advanced exercise options with practical dosage already included.',
    tagline: 'Mobilize. Activate. Strengthen. Stabilize.',
  },
  {
    number: '02',
    name: 'Knee Rehabilitation & Strengthening',
    text: 'Organize knee-focused work using quadriceps, hamstring and glute strengthening, squat patterns, step progressions, balance and unilateral control.',
    detail: 'Exercise difficulty progresses from basic control toward more demanding strength work.',
    tagline: 'Control. Strengthen. Progress.',
  },
  {
    number: '03',
    name: 'Ankle Rehabilitation & Strengthening',
    text: 'Develop ankle mobility, calf strength, tibialis strength, foot control, balance, proprioception and single-leg stability.',
    detail: 'Use progressive exercises according to current control and capacity.',
    tagline: 'Mobility. Balance. Strength. Control.',
  },
  {
    number: '04',
    name: 'Elbow, Wrist & Hand Rehabilitation & Strengthening',
    text: 'Access progressive exercises for elbow strength, forearm rotation, wrist control, grip and hand function.',
    detail: 'Includes practical strengthening options from basic control to progressive loading.',
    tagline: 'Move. Grip. Control. Strengthen.',
  },
  {
    number: '05',
    name: 'Spine & Hip Rehabilitation & Strengthening',
    text: 'Combine trunk control, core stability, hip mobility, glute strength, anti-rotation, hinge patterns and unilateral exercises.',
    detail: 'Build progressively toward stronger and more controlled functional movement.',
    tagline: 'Mobility. Core. Hip strength. Function.',
  },
]

export const sampleMeta = [
  ['Target area', 'Shoulder'],
  ['Level', 'Beginner / Intermediate'],
  ['Equipment', 'Resistance Band'],
  ['Goal', 'Rotator Cuff Strength & Control'],
] as const

export const sampleRows = [
  ['Sets', '3'],
  ['Reps', '10–12'],
  ['Rest', '45–60 seconds'],
  ['Regression', 'Lighter resistance'],
  ['Progression', 'Gradually increase resistance'],
  ['Coaching cue', 'Keep the elbow controlled and close to the body.'],
] as const

export const exerciseStructure = [
  'Starting Position',
  'Execution',
  'Sets',
  'Reps / Time',
  'Rest',
  'Regression',
  'Progression',
]

export const differentiators = [
  {
    icon: 'book',
    title: 'Practical exercises ready to follow',
    text: 'Open the appropriate volume and access exercises already organized by body area and level.',
  },
  {
    icon: 'clipboard',
    title: 'Dosage already included',
    text: 'Sets, reps or time, rest periods and progressions are included where appropriate.',
  },
  {
    icon: 'trend',
    title: 'Beginner → Advanced options',
    text: 'Move from basic control toward progressively more demanding exercise variations.',
  },
  {
    icon: 'home',
    title: 'Home exercise options',
    text: 'Use bodyweight and simple equipment when gym access is not available.',
  },
  {
    icon: 'gym',
    title: 'Gym exercise options',
    text: 'Continue progression with cables, dumbbells, machines and bands.',
  },
  {
    icon: 'timer',
    title: 'Less time organizing',
    text: 'Keep the exercise library, progressions and practical routines together in one system.',
  },
] as const
